import { useLayoutEffect, useRef } from "react";

// CSS transforms do not remove clipped content from the accessibility tree.
export default function useMovingContentAccessibility() {
  const viewportRef = useRef(null);

  useLayoutEffect(() => {
    const viewport = viewportRef.current;
    if (!viewport) return;
    const originalTabIndexes = new Map();
    let frame;

    const update = () => {
      const bounds = viewport.getBoundingClientRect();
      viewport.querySelectorAll("[data-moving-item]").forEach((item) => {
        const rect = item.getBoundingClientRect();
        // A partially visible item stays readable; fully clipped items do not.
        const visible = rect.width > 0 && rect.right > bounds.left && rect.left < bounds.right;
        item.toggleAttribute("inert", !visible);
        if (visible) item.removeAttribute("aria-hidden");
        else item.setAttribute("aria-hidden", "true");

        const targets = [item, ...item.querySelectorAll("a[href], button, input, select, textarea, iframe, [tabindex], [contenteditable]")];
        targets.forEach((target) => {
          if (!visible) {
            if (!originalTabIndexes.has(target)) originalTabIndexes.set(target, target.getAttribute("tabindex"));
            target.setAttribute("tabindex", "-1");
          } else if (originalTabIndexes.has(target)) {
            const original = originalTabIndexes.get(target);
            if (original === null) target.removeAttribute("tabindex");
            else target.setAttribute("tabindex", original);
            originalTabIndexes.delete(target);
          }
        });
      });
      frame = requestAnimationFrame(update);
    };
    update();
    return () => {
      cancelAnimationFrame(frame);
      originalTabIndexes.forEach((value, target) => {
        if (value === null) target.removeAttribute("tabindex");
        else target.setAttribute("tabindex", value);
      });
    };
  }, []);

  return viewportRef;
}
